module.exports = __webpack_public_path__ + "img/bg.082e1559.gif";